import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { ListBox } from "primereact/listbox";
import { SplitButton } from "primereact/splitbutton";
import { useState } from "react"
import { gtfsFormatDateToYYYYMMDD, holidaysSets, listHolidays, parseDMYDate } from "../helpers/gtfsDateUtils";

export function DateExceptionPropertyListbox({
        id,
        icon,
        options,
        optionLabel,
        optionValue,
        label,
        propertyName,
        emptyMessage,
        onDone,
        pending,
        minDate,
        maxDate
    }) {
    
    const [value,setValue] = useState([]);

    return (
        <>
            <label htmlFor={id + '_' + propertyName}><i className={icon}></i> <span className="ml-2">{label}</span></label>
            <ListBox multiple
                id={id + '_' + propertyName}
                options={options}
                optionLabel={optionLabel}
                optionValue={optionValue}
                emptyMessage={emptyMessage}
                listStyle={{ height: '250px' }}
                value={value}
                onChange={(e) => setValue(e.value)}
            />
            {
                (value.length > 0) 
                    ?
                <Button 
                    label={ (value.length > 1) ? "Usuń zazn. daty" : "Usuń zazn. datę"}
                    icon="fa-solid fa-square-minus"
                    severity="danger" 
                    outlined 
                    className="w-full"
                    onClick={(e) => {
                        onDone(propertyName + '_remove',value);
                        setValue([]);
                        }
                    }
                />
                    :
                <PickDate minDate={minDate} maxDate={maxDate} onDone={onDone} propertyName={propertyName}/>
            }
            <HolidayPicker propertyName={propertyName} minDate={minDate} maxDate={maxDate} onDone={onDone} />
        </>
    )
}

function PickDate({minDate,maxDate,onDone,propertyName}) {
    const [date,setDate] = useState(null);
    return (
        <div className="w-full flex">
            {
                (date) 
                    ? 
                <Button  
                    severity="success"
                    icon="fa-solid fa-square-plus"
                    aria-label="Dodaj"
                    onClick={(e) => {
                        onDone(propertyName + '_add',[gtfsFormatDateToYYYYMMDD(date)]);
                        setDate(null);
                    }}
                />
                    :
                <></>

            }
            <Calendar 
                showIcon
                icon="fa-solid fa-calendar-days"
                placeholder="Dodaj datę do listy"
                dateFormat="dd.mm.yy"
                minDate={minDate}
                maxDate={maxDate}
                value={date}
                onChange={(e) => setDate(e.value)}
            />
        </div>
        

    )

}

function HolidayPicker({propertyName, onDone, minDate, maxDate}) {
    const items = [
        {
            label: 'Wszystkie dni ustawowo wolne od pracy',
            command: () => {
                onDone(propertyName + '_add',listHolidays(minDate,maxDate,holidaysSets[1]));
            }
        },        
        {
            label: '"Duże" święta (Nowy Rok, I i II dn. Wielkanocy, I i II dn. Bożego Narodzenia)',
            command: () => {
                onDone(propertyName + '_add',listHolidays(minDate,maxDate,holidaysSets[2]));
            }
        },
        {
            label: '"Bardzo duże" święta (Nowy Rok, I dn Wielkanocy, I dn. Bożego Narodzenia)',
            command: () => {
                onDone(propertyName + '_add',listHolidays(minDate,maxDate,holidaysSets[3]));
            }
        },
        {
            label: 'Wigilia Bożego Narodzenia i sylwester',
            command: () => {
                onDone(propertyName + '_add',listHolidays(minDate,maxDate,holidaysSets[4]));
            }
        },
        {
            label: 'Triduum Paschalne w Kościele Rzymskokatolickim',
            command: () => {
                onDone(propertyName + '_add',listHolidays(minDate,maxDate,holidaysSets[5]));
            }
        },
        {
            label: 'Wielka Sobota',
            command: () => {
                onDone(propertyName + '_add',listHolidays(minDate,maxDate,holidaysSets[6]));
            }
        },
        {
            label: '2 maja i piątek po Bożym Ciele',
            command: () => {
                onDone(propertyName + '_add',listHolidays(minDate,maxDate,holidaysSets[7]));
            }
        },
    ]

    return (
        <SplitButton
            outlined
            size="small"    
            severity="help"
            className="w-full mt-1"
            icon="fa-solid fa-calendar-xmark"
            label="Dodaj święta do listy"
            model={items}
            menuStyle={{minWidth: '40rem'}}
            onClick={
                () => {
                    onDone(propertyName + '_add',listHolidays(minDate,maxDate,holidaysSets[1]));
                }
            }
        />
    )
}